module.exports = "<p>bulk-generation works!</p>\n"